import type { ReactElement } from "react";
import { CmtsComplaintSourceContainer } from "../../core/containers/domain/masterdataRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  void props.runtime;
  return <CmtsComplaintSourceContainer />;
}

export default Component;
